/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';

import * as l10n from './log-cinematic-sub-section-dns-request.l10n';
import { DnsMessageType } from '../../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.types';
import { TrafficLogCinematicStore } from '../../../traffic-logs/traffic-log-cinematic/traffic-log-cinematic.store';
import './log-cinematic-sub-section-dns-request.component.less';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Component for displaying the DNS Request sub-section in DNS section under traffic log cinematic view.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-sub-section-dns-request',
    templateUrl: './log-cinematic-sub-section-dns-request.component.html',
})
export class LogCinematicSubSectionDnsRequestComponent {
    public readonly dnsRequestInfo$ = this.logCinematicStore.dnsRequestInfo$;

    public readonly connectionLog$ = this.logCinematicStore.connectionLog$;

    public readonly globalL10nKeys = globalL10nKeys;

    public readonly l10nKeys = l10nKeys;

    /**
     * Dns message type helps identifying the current component as dns request.
     */
    public readonly dnsMessageType = DnsMessageType.REQUEST;

    constructor(
        public readonly logCinematicStore: TrafficLogCinematicStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }
}
